<template>
  <PageContainer>
    <div class="page-content weight">
      <div class="title animated">What is your current weight?</div>
      <div>
        <label>
          <input class="desktopInput" :class="{'error': poundsLimit || kgsLimit}" type="text" v-model="lbs" />
          <input class="mobileInput" :class="{'error': poundsLimit || kgsLimit}" type="number" v-model="lbs" />
          <span class="weight-unit-label">{{units}}</span>
        </label>
      </div>
      <div>
        <button class="btn-link light-font" @click="toggleUnits" id="prefer-text">I prefer {{unitsText}}</button>
      </div>

      <p class="info-block" v-if="numbersError">Please enter numbers only</p>
      <p class="info-block">
        It’s OK if you don’t know your exact weight. If you decide to make a HealthyWager, you will weigh in using our app.
      </p>
      <p class="info-block" v-if="poundsLimit">Please enter a value between 75 and 600.</p>
      <p class="info-block" v-if="kgsLimit">Please enter a value between 35 and 275.</p>
      <p class="info-block" v-if="goalError">The weight you have entered is less than the amount of weight you want to lose. Enter a weight more than the amount of weight you want to lose.</p>
    </div>

    <div class="footer-container">
      <ButtonNext :onClick="updateWeight" :isDisabled="invalidForm || disabled" :text="'Next'" />
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ProgressBar from '../../shared/components/ProgressBar';
import Trackeable from '../../Trackeable';
import Globalized from '../../shared/components/Globalized';
import { navigateTo, ROUTE_NAMES } from '../router';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressFull from '../mixins/ProgressFull';

export default {
  components: {
    ButtonNext,
    PageContainer,
    ProgressBar
  },
  data() {
    return {
      lbs: this.$store.state.nyop.pounds,
      useLbs: this.$store.state.nyop.units === 'lbs',
      disabled: null
    }
  },
  mixins: [Trackeable, Globalized, ProgressFull],
  computed: {
    units: function() {
      return this.useLbs ? 'lbs' : 'kg';
    },
    unitsText: function() {
      return this.useLbs ? 'kilograms' : 'pounds';
    },
    numbersError: function() {
      return this.lbs && isNaN(this.lbs);
    },
    poundsLimit: function() {
      return this.lbs && this.useLbs && (this.lbs > 600 || this.lbs < 75);
    },
    kgsLimit: function() {
      return this.lbs && !this.useLbs && (this.lbs > 275 || this.lbs < 35);
    },
    goalError: function() {
      return this.lbs && (this.lbs <= this.$store.state.nyop.bet.goal);
    },
    invalidForm: function() {
      return (
        !this.lbs || this.numbersError || this.poundsLimit || this.kgsLimit || this.goalError
      );
    }
  },
  beforeCreate: function() {
    this.disabled = null;
  },
  methods: {
    updateWeight: function() {
      this.disabled = 'disabled';
      this.$store.commit('updateWeight', this.lbs);
      navigateTo(this.$router, ROUTE_NAMES.Age);
    },
    toggleUnits: function() {
      this.useLbs = !this.useLbs;
      this.$store.commit('updateUnits', this.useLbs ? 'lbs' : 'kg');
    }
  }
}
</script>
